export default __webpack_public_path__ + "static/brokers-image-3-e5b06fe6fad7e9433a037b35267da921.png";